import Valkyrie, { viArrowLeft } from "@sippy-platform/valkyrie";

import { Button } from "@mui/material";
import { cn } from "cn";

function Root({ className, id, ...props }) {
  return (
    <div
      className={cn(
        "group @container/maindetail grid h-dvh grid-cols-1 @3xl/outlet:grid-cols-[316px_auto] @7xl/outlet:grid-cols-[366px_auto]",
        className,
      )}
      data-id={id}
      {...props}
    />
  );
}

function Main({ className, ...props }) {
  return (
    <div
      className={cn(
        "@container/main h-full overflow-y-auto overscroll-contain px-4 pt-16 pb-4 @max-3xl/outlet:group-data-id:hidden @3xl/outlet:pe-0",
        className,
      )}
      {...props}
    />
  );
}

function Detail({ className, ...props }) {
  return (
    <div
      className={cn(
        "@container/detail container mx-auto flex h-full max-w-5xl flex-col gap-4 overflow-y-auto overscroll-contain px-4 pt-20 pb-4 @max-3xl/outlet:group-not-data-id:hidden",
        className,
      )}
      {...props}
    />
  );
}

function BackButton(props) {
  return (
    <Button icon plain variant="secondary" to=".." className="shrink-0 @3xl/outlet:hidden" {...props}>
      <Valkyrie icon={viArrowLeft} />
    </Button>
  );
}

export const MainDetail = { Root, Main, Detail, BackButton };
